/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import { SvgIcon, colors } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import { noop } from 'lodash';
import * as React from 'react';

const MinimizeIcon: React.FC<CustomSvgIcon> = ({
    id = '',
    className = '',
    iconColor = colors.common.white,
    onClick = noop
}) => (
    <SvgIcon
        className={className}
        id={id}
        onClick={onClick}
    >
        <svg
            fill={iconColor}
            viewBox='0 0 10 10'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.468182 2.74091V3.65H3.65V0.468182H2.74091V2.25909L0.468182 0L0 0.468182L2.25909 2.74091H0.468182ZM0.468182 10L2.74091 7.74091V9.53182H3.65V6.35H0.468182V7.25909H2.25909L0 9.53182L0.468182 10ZM7.25909 7.74091L9.53182 10L10 9.53182L7.74091 7.25909H9.53182V6.35H6.35V9.53182H7.25909V7.74091V7.74091ZM9.53182 3.65V2.74091H7.74091L10 0.468182L9.53182 0L7.25909 2.25909V0.468182H6.35V3.65H9.53182V3.65Z'
                fill={iconColor}
                id='Minimize Icon'
            />
        </svg>
    </SvgIcon>
);

export default MinimizeIcon;